import { configureStore } from "@reduxjs/toolkit";
import Items from "./slices/Items";
import Client from "./slices/Client";
import Demo from "./slices/Demo";

export const store = configureStore({
  reducer: {
    Items,
    Client,
    Demo,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
